<template>
  <location></location>
  <div class="single-container">
    <ArticleContent v-if="columnInfo"
      :content="columnInfo.singlePageContent"
      :attachment-file-list="columnInfo.attachmentFileList"
    />
    <div v-else class="system-maintenance">
       <el-empty description="您预览的栏目未维护任何内容，请先去维护。" />
    </div>
  </div>
</template>

<script setup>
// #region 引用
import ArticleContent from '@/views/components/website/article-content/ArticleContent.vue';
import useSSRInitialStateStore from '@/stores/ssr-state';
import { useSSRContext } from '@/ssr/use-context';
import location from '../components/Location.vue';

// #endregion

// #region props/emit

// #endregion

// #region 变量/常量
// 栏目信息

// 导航地址信息
const columnInfo = ref();
const previewId = ref();
// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

// SSR 期间同步读取数据（父组件 onServerPrefetch 已设置）
if (import.meta.env.SSR) {
  const ssrContext = useSSRContext();
  columnInfo.value = ssrContext.initialState?.data?.current?.columnInfo;
  previewId.value = ssrContext.initialState?.data?.current?.previewId;
} else {
  // 客户端从 initialState 读取数据
  const ssrInitialState = useSSRInitialStateStore();
  columnInfo.value = ssrInitialState.data.current.columnInfo;
  previewId.value = ssrInitialState.data.current.previewId;
}

// #endregion
</script>
<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

/* [PC端优化-2026-03-10] 现代化升级 */
@media screen and (min-width: 1181px) {
  .single-container {
    max-width: 1200px;
    padding: 40px 60px;
    margin: 0 auto 28px;
    overflow: hidden;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    }
  }

  .system-maintenance {
    padding: 60px 0;
  }
}

/* [移动端优化-2026-03-10] 现代化升级 */
@media screen and (max-width: 1180px) {
  .single-container {
    padding: 4vw;
    margin: 0 3vw 4vw;
    overflow: hidden;
    font-size: 4vw;
    background: #fff;
    border-radius: 3vw;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:active {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  .system-maintenance {
    padding: 8vw 0;
  }
}
</style>
